export const ITEMS_PER_PAGE = 24
export const SELLER_DECATHLON = `1`
export const INSURANCE_SELLER = 'Seguro e Garantia'
export const HAVE_WINDOW = typeof window !== `undefined`

export const GIFT_CARD_PRODUCT_ID = '11113'
